import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="relative py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 overflow-hidden">
      {/* Éléments décoratifs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-primary/20 to-red-600/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-gradient-to-tl from-red-500/20 to-primary/10 rounded-full blur-3xl"></div>
      
      <div className="relative container mx-auto px-6 lg:px-8">
        {/* En-tête de section */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-primary to-red-600 text-white text-sm font-semibold rounded-full mb-6">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
            Contact & Documents
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Rejoignez-nous <span className="text-primary">dès maintenant</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Toutes les informations et documents nécessaires pour commencer votre parcours avec l'ECKSD
          </p>
        </div>

        {/* Grid principal */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-7xl mx-auto">
          
          {/* Section Contact */}
          <div className="space-y-8">
            {/* Informations de contact */}
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
                <svg className="w-6 h-6 text-primary mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                Nous contacter
              </h3>
              
              <div className="space-y-4">
                <div className="flex items-center space-x-4 p-4 bg-white/5 rounded-2xl hover:bg-white/10 transition-colors duration-300">
                  <div className="w-12 h-12 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Email</p>
                    <a href="mailto:ecolecksd@gmail.com" className="text-white hover:text-red-400 transition-colors duration-300">
                      ecolecksd@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Section d'inscription rapide */}
            <div className="bg-gradient-to-br from-primary/20 to-red-600/10 backdrop-blur-sm rounded-3xl p-8 border border-primary/30">
              <h3 className="text-2xl font-bold text-white mb-4">Prêt à commencer ?</h3>
              <p className="text-gray-300 mb-4">
                Contactez-nous pour un cours d'essai gratuit ou pour toute question sur nos cours.
              </p>
              <div className="bg-white/10 rounded-2xl p-4 mb-6">
                <h4 className="text-xl font-bold text-white mb-2">Rejoignez notre équipe</h4>
                <p className="text-gray-300">Une communauté passionnée vous attend</p>
              </div>
              <a 
                href="mailto:ecolecksd@gmail.com?subject=Demande d'information ECKSD"
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-primary to-red-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                <span>Nous écrire</span>
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
              </a>
            </div>
          </div>

          {/* Section Documents */}
          <div className="space-y-8">
            {/* Documents d'inscription */}
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
                <svg className="w-6 h-6 text-primary mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                Documents officiels
              </h3>
              
              <div className="grid grid-cols-1 gap-4">
                {[
                  {
                    title: "Flyer d'information",
                    description: "Toutes les infos sur nos cours",
                    link: process.env.PUBLIC_URL + 'flyers/flyer_2026-2027.pdf',
                    icon: "📄"
                  },
                  {
                    title: "Formulaire d'inscription",
                    description: "Demande de licence",
                    link: process.env.PUBLIC_URL + 'formulaires/Formulaire_Licence_ECKSD.pdf',
                    icon: "📝"
                  },
                  {
                    title: "Règlement intérieur",
                    description: "Règles de fonctionnement du club",
                    link: process.env.PUBLIC_URL + 'formulaires/REGLEMENT-INTERIEUR.pdf',
                    icon: "📋"
                  },
                  {
                    title: "Attestation règlement",
                    description: "Engagement sur l'honneur",
                    link: process.env.PUBLIC_URL + 'formulaires/attestation-Reglement-interieur-ecksd.pdf',
                    icon: "✅"
                  },
                  {
                    title: "Certificat médical - Enfants",
                    description: "Attestation santé mineurs",
                    link: process.env.PUBLIC_URL + 'formulaires/ATTESTATION-SUR-LHONNEUR-SPORTIF-MINEUR_ANNEXE2_M_2.pdf',
                    icon: "🏥"
                  },
                  {
                    title: "Certificat médical - Adultes",
                    description: "Attestation santé adultes",
                    link: process.env.PUBLIC_URL + 'formulaires/ATTESTATION-SUR-LHONNEUR-SPORTIF_ANNEXE2_M_2.pdf',
                    icon: "🏥"
                  }
                ].map((doc, index) => (
                  <a
                    key={index}
                    href={doc.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-center space-x-4 p-4 bg-white/5 hover:bg-white/10 rounded-2xl transition-all duration-300 hover:scale-105"
                  >
                    <div className="text-2xl">{doc.icon}</div>
                    <div className="flex-1">
                      <h4 className="text-white font-semibold group-hover:text-primary transition-colors duration-300">
                        {doc.title}
                      </h4>
                      <p className="text-gray-400 text-sm">{doc.description}</p>
                    </div>
                    <svg className="w-5 h-5 text-gray-400 group-hover:text-primary transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                    </svg>
                  </a>
                ))}
              </div>
            </div>

           
          </div>
        </div>

        {/* Section informations complémentaires */}
        <div className="mt-16 bg-white/5 backdrop-blur-sm rounded-3xl p-6 md:p-8 border border-white/10">
          <div className="text-center mb-8">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4">Questions fréquentes</h3>
            <p className="text-gray-300">Les réponses aux questions les plus courantes</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-white mb-1 md:mb-2">Faut-il une expérience ?</h4>
              <p className="text-gray-300 text-xs md:text-sm">Aucune expérience n'est requise. Nos cours s'adaptent à tous les niveaux.</p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-white mb-1 md:mb-2">Quel équipement ?</h4>
              <p className="text-gray-300 text-xs md:text-sm">Une tenue de sport suffit pour commencer.</p>
            </div>
            
            <div className="text-center col-span-2 md:col-span-1">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-primary to-red-600 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h4 className="text-sm md:text-base font-semibold text-white mb-1 md:mb-2">À partir de quel âge ?</h4>
              <p className="text-gray-300 text-xs md:text-sm">Dès 8 ans pour les enfants, aucune limite d'âge pour les adultes.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
